var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCreditor',{attrs:{"header":"ลูกหนี้","img_header":_vm.header_image,"link_back":"creditor/all"}}),_c('MenuDebtor'),_c('Transfer_from_debtor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }